import styled from 'styled-components';

export const MessageError = styled.p`
  font-size: 16px;
  text-align: center;
  width: 100%;
  color: #ce0327;
`;
